import React from "react";
import { I18n } from "aws-amplify";
import { SignIn, ForgotPassword } from "aws-amplify-react";
import CustomSignUp from "./CustomSignUp";
import {
  FormSection,
  FormField,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  Hint,
  Input,
  InputLabel,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

export default class CustomSignIn extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
  }

  showComponent(theme) {
    const { authState, hide = [], override = [] } = this.props;
    if (hide && hide.includes(CustomSignIn)) return null;
    const hideSignUp =
      !override.includes("SignUp") &&
      hide.some(component => component === CustomSignUp);
    const hideForgotPassword =
      !override.includes("ForgotPassword") &&
      hide.some(component => component === ForgotPassword);

    return (
      <FormSection theme={theme}>
        {authState === "signedUp" && <h1>Account confirmation successful!</h1>}
        <SectionHeader theme={theme}>
          {I18n.get("Sign in to your account")}
        </SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel theme={theme}>{I18n.get("Email")} *</InputLabel>
            <Input
              autoFocus
              placeholder={I18n.get("Enter your email")}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
            />
          </FormField>
          <FormField theme={theme}>
            <InputLabel theme={theme}>{I18n.get("Password")} *</InputLabel>
            <Input
              placeholder={I18n.get("Enter your password")}
              theme={theme}
              key="password"
              type="password"
              name="password"
              onChange={this.handleInputChange}
            />
            {!hideForgotPassword && (
              <Hint theme={theme}>
                {I18n.get("Forgot your password? ")}
                <Link
                  theme={theme}
                  onClick={() => this.changeState("forgotPassword")}
                >
                  {I18n.get("Reset password")}
                </Link>
              </Hint>
            )}
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button
              theme={theme}
              onClick={this.signIn}
              disabled={this.state.loading}
            >
              {I18n.get("Sign In")}
            </Button>
          </SectionFooterPrimaryContent>
          {!hideSignUp && (
            <SectionFooterSecondaryContent theme={theme}>
              {I18n.get("No account? ")}
              <Link theme={theme} onClick={() => this.changeState("signUp")}>
                {I18n.get("Create account")}
              </Link>
            </SectionFooterSecondaryContent>
          )}
        </SectionFooter>
      </FormSection>
    );
  }
}
